import styled from "styled-components";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";

const FooterInputContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
  font-family: Inter;

  .footer_input_title {
    color: #263645;
    font-size: 16px !important;
    margin: 0px;
    font-weight: 600 !important;
  }

  .footer_form {
    max-height: 45px;
    font-family: Inter;
  }

  .footer_fieldset {
    padding: 0px;
    min-height: 100%;
    height: 100%;
    border: solid 1.4px #263645;
    text-transform: capitalize;
    border-radius: 5px;
  }

  .footer_container_inputs {
    display: grid;
    grid-template-columns: 70% 1fr;
    margin-top: -12px;
    height: 45px;
  }

  input {
    border: none;
    outline: none;
    height: 100%;
  }

  .footer_input_email {
    background: transparent;
    color: #263645;
    font-size: 15px;
    font-family: Inter;
    font-weight: 600;
    margin-left: 10px;
  }

  .footer_input_email::placeholder {
    color: #263645;
    font-weight: 500;
  }

  .footer_input_submit {
    background: transparent;
    border-left: solid 1.4px #263645;
    color: #263645;
    font-size: 14px;
    font-weight: 600;
    font-family: Inter;
    text-transform: capitalize;
  }

  .footer_legend {
    color: #263645;
    font-weight: 600;
    margin-left: 10px;
  }

  .footer_input_paragraph {
    font-size: 10.5px;
    color: #263645;
    margin-top: 20px;
  }

  //VERSION MOBILE
  .footer_container_inputs_mobile {
    display: grid;
    grid-template-columns: 70% 1fr;
    margin-top: -10px;
    height: 45px;
  }

  .footer_input_paragraph_mobile {
    font-size: 10.5px;
    color: #242424;
    margin-top: 15px;
    text-align: center;
  }

  .footer_input_title_mobile {
    color: #263645;
    margin-top: 15px;
    font-size: 16px !important;
    font-weight: 600 !important;
    margin-bottom: 10px;
  }
`}
`;

export const FooterInput = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <FooterInputContainer>
      <div className="footer_input_container">
        <h6 className={!isMobile ? "footer_input_title" : "footer_input_title_mobile"}>
          {t("Footer.Onboard.FormInput.title")}
        </h6>
        <form action="" method="post" className="footer_form">
          <fieldset className="footer_fieldset">
            <legend className="footer_legend">{t("Footer.Onboard.FormInput.legend")}</legend>
            <div className={!isMobile ? "footer_container_inputs" : "footer_container_inputs_mobile"}>
              <input
                type="email"
                className="footer_input_email"
                placeholder={t("Footer.Onboard.FormInput.InputPlaceholder")}
              />
              <input
                type="submit"
                value={t("Footer.Onboard.FormInput.valueButtonSubmit")}
                className="footer_input_submit"
              />
            </div>
          </fieldset>
        </form>
        <p className={!isMobile ? "footer_input_paragraph" : "footer_input_paragraph_mobile"}>
          {t("Footer.Onboard.FormInput.paragraph")}
        </p>
      </div>
    </FooterInputContainer>
  );
};
